import {PureComponent} from "react";
import Link from 'Component/Link';


export class NumericBrandList extends PureComponent {
   render() {
       const { nonAlphabets, brandList } = this.props;
      return (
          <ul className="BrandsPage-items">
              {
                  brandList.filter(list => nonAlphabets.includes(list.title.charAt(0))).map(filtrated => (
                     <li className="BrandsPage-item">
                         <Link to={filtrated.url_alias}>
                         {filtrated.title}
                         </Link>
                     </li>
                  ))
              }
          </ul>
      )
   }
}
export default NumericBrandList;


